export default {
    // API_BASE_URL: "https://cpsb.nairobi.go.ke:8082/cpsb/",
    // API_COUNTIES_BASE_URL: "https://cpsb.nairobi.go.ke:8081/api/v1",
    API_BASE_URL: "https://cpsb.nairobi.go.ke:8081/api/v1",
    API_COUNTIES_BASE_URL: "https://cpsb.nairobi.go.ke:8081/api/v1",
    PAGINATOR_SIZE: 10,
};
